module.exports = __webpack_public_path__ + "static/hda@2x-98b7d0c564539e2ce0ccf9bb3ba20276.jpg";